<template>
    <div>
        <div class="columns">
            <bids-search :bids="bids"></bids-search>
        </div>
        <div class="columns mb-0">
            <div class="column has-text-centered display-flex total-info-section">
                <div class="total-info-btn  total-bid">
                    <div class="total-icon"><i class="fas fa-gavel"></i></div>
                    <div class="total-txt">
                        Total Bids: {{ totalBids }}
                    </div>
                </div>
                <div class="total-info-btn  total-win">
                    <div class="total-icon"><img src="/static/images/icons/gold-trophy.png"></div>
                    <div class="total-txt">
                        Total Win
                    </div>
                </div>
            </div>
        </div>
        <app-loader :loading="getLoaderStatus" :color="options.color" :size="options.size"></app-loader>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="table-container center-column bid-table-container">
                <table class="theme-table table is-responsive is-fullwidth is-striped bids-table">
                    <thead>
                    <tr>
                        <th v-if="isAdmin && isUserSinglePage" style="min-width: 80px;">Action</th>
                        <th v-if="isUserSinglePage">Client</th>
                        <th class="long"><span @click="setOrder('lot_date')" class="link">Day</span></th>
                        <th>Photos</th>
                        <th><span @click="setOrder('bid')" class="link">Lot</span></th>
                        <th class="tooltip" data-tooltip="Translation">T</th>
                        <th>Bid<!--<br>Nego--></th>
                        <th class="long">Result</th>
                        <th><span @click="setOrder('auction_name')" class="link">Auction</span></th>
                        <th><span @click="setOrder('company')" class="link">Brand</span></th>
                        <th><span @click="setOrder('model_name')" class="link">Model</span></th>
                        <th><span @click="setOrder('model_type_en')" class="link">Chassis</span></th>
                        <th><span @click="setOrder('mileage_num')" class="link">Km's</span></th>
                        <th><span @click="setOrder('model_year_en')" class="link">Year</span></th>
                        <th><span @click="setOrder('displacement')" class="link">CC.</span></th>
                        <th><span @click="setOrder('transmission')" class="link">Trans.</span></th>
                        <th><span @click="setOrder('scores')" class="link" data-tooltip="Score">Sc.</span></th>
                        <th class="tooltip" data-tooltip="Position">Po.</th>
                        <th>Win</th>
                        <th>Status</th>
                        <th>Catalogue </th>
                        <th v-if="isAdmin"><span @click="setOrder('group_id')" class="link">Group / Max</span></th>
                    </tr>
                    </thead>
                    <bid-table-row v-for="(bid, i) in bids" :bid="bid" :key="bid.id" :i="i"></bid-table-row>
                </table>
                <div class="columns">
                    <div class="column has-text-centered" v-if="!isLastPage">
                        <button class="button is-large"
                                @click.prevent="loadMore()">
                            <span>Load More</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bidBox from './BidBox'
    import BidsSearch from './BidsSearch'
    import appLoader from 'vue-spinner/src/ClipLoader'
    import BidTableRow from './BidTableRow.vue'
    import moment from 'moment'

    export default {
        components: {
            bidBox: bidBox,
            bidsSearch: BidsSearch,
            appLoader: appLoader,
            bidTableRow: BidTableRow
        },
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        computed: {
            totalBids() {
                return this.$store.getters.getTotalBids
            },
            bids() {
                return this.$store.getters.getBids
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            isLastPage() {
                return this.$store.getters.isLastBidsPage
            },
            isUserSinglePage() {
                return location.pathname.split('/')[1] !== 'users'
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            }
        },
        methods: {
            loadMore() {
                this.$store.dispatch('loadMoreBids')
            },
            isMobile() {
                return (window.innerWidth <= 760)
            },
            setOrder(column) {
                this.$store.getters.getOrderType === 'ASC' ? this.$store.dispatch('setNewOrderType', 'DESC') : this.$store.dispatch('setNewOrderType', 'ASC')
                this.$store.dispatch('setNewOrderColumn', column)
                this.$store.dispatch('fetchBids')
            }
        },
        created() {
            this.$store.dispatch('clearBidsQuery')
            if (location.pathname.split('/')[1] === 'users') {
                this.$store.dispatch('setNewBidsUserId', this.$route.params.id)
            }
            this.$store.dispatch('setNewOrderColumn', 'group_id')
            this.$store.dispatch('fetchBids')

        }
    }
</script>

<style>
    .table-container {
        width: 100%;
    }

    table {
        width: 100%;
    }

    th {
        font-size: small;
    }

    .long {
        min-width: 75px;
    }

    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }

    .table-container {
        /*padding-top: 20px;*/
        max-width: 100%;
        overflow: -moz-scrollbars-vertical;
    }

    .bid-table-container {
        margin-top: 20px
    }
</style>



// WEBPACK FOOTER //
// src/components/Bids/BidsTable.vue